import React, { useState } from 'react';
import '../App.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

function SmsConsent() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    consent: false
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.consent) {
      setStatus({ type: 'error', message: 'Please agree to the SMS terms to continue.' });
      return;
    }

    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await fetch(`${API_BASE_URL}/sms-consent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          phone: formData.phone
        })
      });

      if (response.ok) {
        setStatus({ type: 'success', message: 'Success! You are now signed up for SMS notifications.' });
        setFormData({ name: '', phone: '', consent: false });
      } else {
        const data = await response.json();
        setStatus({ type: 'error', message: data.error || 'Error signing up. Please try again.' });
      }
    } catch (err) {
      console.error('SMS consent error:', err);
      setStatus({ type: 'error', message: 'Network error. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="is-preload">
      <div id="wrapper" className="divided">
        {/* Sign Up Form Section */}
        <section className="wrapper style1 align-left">
            <div className="content-section">
              <section>
                <h1 style={{ marginBottom: '0.5rem', whiteSpace: 'nowrap' }}><img src={`${process.env.PUBLIC_URL}/images/logo_small.png`} alt="Tegrat Auto" style={{ height: '5em', marginRight: '0.5rem', verticalAlign: 'middle' }} />SMS Notifications Sign Up</h1>
                <p style={{ marginBottom: '2rem', color: '#666' }}>
                  Sign up to receive text message updates about your rental status and account.
                </p>

                {status.message && (
                  <div style={{
                    padding: '15px',
                    marginBottom: '20px',
                    borderRadius: '4px',
                    backgroundColor: status.type === 'success' ? '#d4edda' : '#f8d7da',
                    color: status.type === 'success' ? '#155724' : '#721c24',
                    border: `1px solid ${status.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`
                  }}>
                    {status.message}
                  </div>
                )}

                <form onSubmit={handleSubmit} style={{ maxWidth: '500px' }}>
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '16px',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+1 (555) 000-0000"
                      required
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '16px',
                        border: '1px solid #ccc',
                        borderRadius: '4px'
                      }}
                    />
                  </div>

                  <div style={{
                    marginBottom: '20px',
                    padding: '15px',
                    backgroundColor: '#f9f9f9',
                    borderLeft: '4px solid #333',
                    fontSize: '0.95rem'
                  }}>
                    <input
                      type="checkbox"
                      id="consent"
                      name="consent"
                      checked={formData.consent}
                      onChange={handleInputChange}
                    />
                    <label htmlFor="consent">
                      I agree to receive text messages from Tegrat Auto regarding my rental status
                      and account updates. Message frequency varies. Message and data rates may apply.
                      Reply STOP to opt out.
                    </label>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="button primary"
                    style={{
                      opacity: isSubmitting ? 0.6 : 1,
                      cursor: isSubmitting ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {isSubmitting ? 'Signing Up...' : 'Sign Up'}
                  </button>
                </form>

                <p style={{ marginTop: '20px', fontSize: '0.9rem', color: '#666' }}>
                  By signing up, you agree to our{' '}
                  <a href="#privacy" style={{ color: '#333' }}>Privacy Policy</a> and{' '}
                  <a href="#terms" style={{ color: '#333' }}>Terms of Service</a>.
                </p>
              </section>

              <hr style={{ margin: '40px 0', border: 'none', borderTop: '1px solid #ddd' }} />

              <section>
                <h2>How We Use SMS</h2>
                <p>
                  Tegrat Auto sends SMS text messages to provide you with important
                  updates about your vehicle rental, including:
                </p>
                <ul>
                  <li>Rental confirmation and invoice</li>
                  <li>Payment receipts and transaction updates</li>
                  <li>Rental contract availability notifications</li>
                  <li>Important account information</li>
                </ul>
              </section>

              <section id="terms">
                <h2>Your Consent</h2>
                <p>
                  By providing your mobile phone number during the rental process, you
                  consent to receive automated text messages from Tegrat Auto at the
                  phone number provided. Consent is not a condition of purchase.
                </p>
                <p>
                  <strong>Message Frequency:</strong> You will receive transactional
                  messages related to your rentals and payments. Typical frequency is
                  1-3 messages per rental transaction.
                </p>
              </section>

              <section>
                <h2>Standard Rates & Charges</h2>
                <p>
                  Message and data rates may apply depending on your mobile carrier's plan.
                  Please contact your mobile carrier for details about your messaging plan.
                </p>
              </section>

              <section>
                <h2>Opt-Out Instructions</h2>
                <p>
                  You may opt out of receiving SMS messages at any time by:
                </p>
                <ul>
                  <li>Replying <strong>STOP</strong> to any message from us</li>
                  <li>Contacting your rental agent and requesting to opt out</li>
                  <li>Calling us at (317) 709-9519</li>
                </ul>
                <p>
                  After opting out, you will no longer receive SMS notifications, but
                  email notifications will continue unless separately opted out.
                </p>
              </section>

              <section>
                <h2>Help & Support</h2>
                <p>
                  For help or questions about SMS messages:
                </p>
                <ul>
                  <li>Reply <strong>HELP</strong> to any message from us</li>
                  <li>Contact us at: info@tegratauto.com</li>
                  <li>Call: (317) 709-9519</li>
                </ul>
              </section>

              <section id="privacy">
                <h2>Privacy</h2>
                <p>
                  Your phone number is used solely for sending rental-related
                  notifications. We do not share your information with third parties
                  for marketing purposes. Your privacy is important to us, and we
                  maintain strict data protection practices in compliance with applicable laws.
                </p>
              </section>

              <section>
                <h2>Contact Information</h2>
                <p>
                  <strong>Tegrat Auto Rental</strong><br/>
                  Indianapolis, IN<br/>
                  Phone: (317) 709-9519<br/>
                  Email: info@tegratauto.com<br/>
                  Website: https://tegratauto.com
                </p>
              </section>

              <p className="last-updated">
                Last Updated: January 15, 2026
              </p>

              <div style={{ marginTop: '40px', textAlign: 'center' }}>
                <a href="/" className="button">Return to Home</a>
              </div>

            </div>
        </section>

        {/* Footer */}
        <footer className="wrapper style1 align-center">
          <div className="inner">
            <ul className="icons">
              <li><a href="https://www.instagram.com/tegratauto/" className="icon brands style2 fa-instagram"><span className="label">Instagram</span></a></li>
              <li><a href="mailto:info@tegratauto.com" className="icon style2 fa-envelope"><span className="label">Email</span></a></li>
            </ul>
            <p>&copy; Tegrat Auto 2025. &copy; Des Dayton Digital LLC 2025.</p>
          </div>
        </footer>

      </div>
    </div>
  );
}

export default SmsConsent;
